import ChevronUpIcon from '../Icons/ChevronUp'
import IconButton from './IconButton'

interface IButtonUp {
    onClick(event?: any): void
    title?: string
}

const ButtonUp = ({ onClick, title }: IButtonUp) => (
    <IconButton title={title} onClick={onClick}>
        <ChevronUpIcon />
    </IconButton>
)

export default ButtonUp
